import {Component, Inject, Input, Output, EventEmitter} from 'ng-metadata/core';
import {ServiceButtonService} from './serviceButton.service';
import {OPAC_TAB} from './opac.directive';
import {ChangeTabEvent} from './opac.directive';
import {AnalyticsUtils} from "../../../../nddUtils/analyticsUtils.service";
import {OpacService} from './opac.service';
import {TranslationService} from "../../../../translate/translation.service";

const _get = require('lodash/get');
const isEqual = require('lodash/isEqual');

@Component({
    selector: 'prm-service-button',
    templateUrl: 'components/search/fullView/getit/opac/service-button.html',
})
export class PrmServiceButton {

    @Input() public service;
    @Input() public parentTab: OPAC_TAB;
    @Input() public requestParameters;
    @Input() public envUrl;
    @Input() private item;

    @Output() private changeTabEvent: EventEmitter<ChangeTabEvent> = new EventEmitter();
    private buttonAriaLabel: string;

    constructor(private serviceButtonService: ServiceButtonService,
        private analyticsUtils: AnalyticsUtils,
        private opacService : OpacService,
                @Inject('actionIcons') public actionIcons,
                @Inject('$translate') private $translate,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                private translationService: TranslationService) {
    }

    ngOnInit() {
        this.$translate.onReady().then(() => {
            this.buttonAriaLabel = (this.$translate.instant(this.service.type) + " " + _get(this.requestParameters, 'itemdescription', '')).trim();
        });
    }

    public getServiceDetails() {
        if (isEqual(this.service['service-type'],'OvL') || isEqual(this.service['service-type'],'GENERAL_ELECTRONIC')) {
            this.sendAnalytics(this.analyticsUtils.eventsNames.ADDITIONAL_LINKS);
            let link: string = this.service['link-to-service'];
            if (link !== undefined) {
                window.open(link, '_blank');
            }
        } else {
            if (this.envUrl) {
                this.service['link-to-service'] += "&envURL=" + encodeURIComponent(this.envUrl);
            }
            this.serviceButtonService.makeIlsRequest(this.service, this.requestParameters)
                .then((res) => {
                    let eventData = {
                        referer: this.opacService.currentTabForRequest!=undefined ? this.opacService.currentTabForRequest : this.parentTab,
                        dest: OPAC_TAB.REQUEST
                    };
                    this.$timeout(() => {
                        this.focusOnFirstFormField();
                    }, 500);
                    this.changeTabEvent.emit(eventData);
                });
        }
        if (isEqual(this.service['service-type'],'OvP')){
            this.sendAnalytics(this.analyticsUtils.eventsNames.CREATE_PHYSICAL_REQUEST);
        }
    }

    private focusOnFirstFormField() {
        let firstElement = document.querySelector('.first-item');
        if (firstElement) {
            let elements = Array.from(firstElement.querySelectorAll("*"));
            elements.forEach((el) => {
                if (this.isFocusable(el)) {
                    el.focus();
                }
            });
        }
    }

    private isFocusable(element) {
        const validTypes = ['MD-SELECT', 'MD-CHECKBOX', 'MD-RADIO-GROUP', 'INPUT', 'submit'];
        return element.tagName !== 'FIELDSET' && !element.disabled && validTypes.includes(element.tagName);
    }

    public getServiceName(name) {
        return this.translationService.translateInstantWithDefault(name, name);
    }


    private sendAnalytics(eventName) {
        let payload = this.getAnalyticsPayload(eventName);
        this.analyticsUtils.trackUsage(eventName, payload);
    }

    private getAnalyticsPayload(eventName) {
        let payload = {};
        switch (eventName) {
            case this.analyticsUtils.eventsNames.CREATE_PHYSICAL_REQUEST:
                payload = {
                    "Request Type": this.getAnalyticsRequestType(),
                    "Request Action Type": "Open",
                    "Record ID": _get(this.item, 'pnx.control.recordid[0]'),
                    "Record Title": _get(this.item, 'pnx.display.title[0]'),
                    "Resource Type": _get(this.item, 'pnx.display.type[0]'),
                    "Level Type": this.requestParameters != (null || undefined) && this.requestParameters.itemid != (null || undefined) ? "Item Level" : "Title Level",
                 }
                break;

                case this.analyticsUtils.eventsNames.ADDITIONAL_LINKS:
                    payload = { 
                        'Additional Link Type': 'GES',
                        'Displayed Link Name': _get(this.service, 'type'),
                        "Record ID": _get(this.item, 'pnx.control.recordid[0]'),
                        "Record Title": _get(this.item, 'pnx.display.title[0]'),
                        "Resource Type": _get(this.item, 'pnx.display.type[0]'),
                        'Page Area': 'Get It'
                    }
                    break;
        
            default:
                break;
        }
        return payload;
    }

    private getAnalyticsRequestType() {
        switch (this.service.type) {
            case "AlmaRequest" :
                return "Holding or Booking Request";
            case "AlmaDigitization":
                return "Digitization Request";
            case "AlmaPurchaseRequest":
                return "Purchase Request";
            case "AlmaItemDigitization":
                return "Digitization Request";
            case  "AlmaItemRequest":
                return "Holding or Booking Request";
            case "AlmaResourceSharing":
                return "Resource Sharing"
            default:
                return this.service.type;
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/serviceButton.directive.ts